import script from "./ImprintsFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./ImprintsFilters.vue?vue&type=script&setup=true&lang=js"

import "./ImprintsFilters.vue?vue&type=style&index=0&id=98483406&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98483406"]])

export default __exports__